import DownloadRounded from '@mui/icons-material/DownloadRounded';
import { Button } from '@mui/material';
import { useState } from 'react';
import { useDataModel } from './api';
import { ExportDialog } from './ExportDialog';

/**
 * Row selection for a list, with an Export button for the picked rows. Spread `table` into the
 * DataTable and render `dialog` next to it. Nothing is selectable when this user may not export
 * the model.
 */
export function useExportSelection(modelName: string) {
  const { model } = useDataModel(modelName);
  const [selected, setSelected] = useState<string[]>([]);
  const [open, setOpen] = useState(false);

  if (!model?.canExport) return { table: {}, dialog: null };
  return {
    table: {
      selected,
      onSelectedChange: setSelected,
      selectionActions: (
        <Button
          size="small"
          variant="contained"
          startIcon={<DownloadRounded />}
          onClick={() => setOpen(true)}
        >
          Export
        </Button>
      ),
    },
    dialog: open && (
      <ExportDialog model={model} ids={selected} open onClose={() => setOpen(false)} />
    ),
  };
}
